<template>
  <div class="form-elements">
    <div class="row" v-show="!download.load">
        <div class="form-group">
            <div class="col-md-6">
                <input type="date" id='data-inicial'>
            </div>
            <div class="col-md-6">
                <input type="date" id='data-final'>
            </div>
        </div>
        <div class="form-group">
            <div class="col-md-12">
                <button @click="getRelatorio()" class="btn btn-primary btn-micro">Gerar Relatório</button>
            </div>
        </div>
    </div>
    <div v-show="download.load">
        <span>Pode demorar um pouco...</span>
        <div class="d-flex justify-content-center">
            <div class="btn-toolbar  d-inline-flex" role="toolbar" aria-label="Toolbar with button groups">
                <component :animation-duration="1000" :is="'SpringSpinner'" :color="'#4AE387'" :size="80"></component>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
  import * as spinners from 'epic-spinners'
  import urlApi from '../../../../router/urlApi'
  import urlApiV2 from '../../../../router/urlApiV2'

  export default {
    name: 'relatorioDoacoes',
    components: {
      ...spinners,
    },
    data () {
      return {
        download: {
          load: false
        },
      }
    },
    methods: {
      getRelatorio () {
        this.download.load = true

        let dataInicial = document.getElementById('data-inicial').value
        let dataFinal = document.getElementById('data-final').value

        const params = {
          data_i: dataInicial,
          data_f: dataFinal,
        }

        this.$http.get(`${urlApiV2}/aulas/praticas/relatorio/praticas-detalhadas`, {
          params
        })
          .then(this.downloadPDF)
          .catch((err) => {
            this.$toasted.show(err.body.mensagem, {
              position: 'top-right',
            })
          })
          .finally(() => {
            this.download.load = false
          })
      },
      downloadPDF (response) {
        let pdf = "data:application/octet-stream;base64," + response.body.dados
				let downloadPDF = document.getElementById("downloadPDF")
				downloadPDF.download = "relatorio-aulas-praticas-enviadas-detalhadas.pdf"
				downloadPDF.href = pdf
        downloadPDF.click()
        this.download.load = false
      },
    },
  }
</script>
